import mountNotesApp from '~/mr_notes/mount_app';
import { initMrPage } from '~/pages/projects/merge_requests/page';
import { lazyCreateRapidDiffsApp } from '~/pages/projects/merge_requests/lazy_create_rapid_diffs_app';

initMrPage(lazyCreateRapidDiffsApp);
mountNotesApp();
